import React from 'react';
import {useSearchParams} from 'react-router-dom';
import GlobalAuthorizationLayout from '../components/GlobalAuthorizationLayout';
import ContractWave from '../apps/Contract/ContractWave';
import ContractFly from '../apps/Contract/ContractFly';
import CheckStaffUserLayout from '../layout/CheckStaffUserLayout';
import CheckViewer from '../layout/CheckViewer';

const ContractPage: React.FC = ({...props}:Record<string, any>) => {
    const { user } = props;
    const [params] = useSearchParams();
    const contract_type = params.get('contract_type')

    return (
    <GlobalAuthorizationLayout>
        <CheckViewer>
            <CheckStaffUserLayout>
                {contract_type === 'aero' ? <ContractFly userInfo={user}/> : <ContractWave userInfo={user}/>}
            </CheckStaffUserLayout>
    </CheckViewer>
</GlobalAuthorizationLayout>
  );
};

export default ContractPage;
